import _ from 'lodash';
import { updateProduct, deleteProduct } from '../../apis/backend';
import {
  displayPriceFormat,
  isIntegerNotNull,
  keyGenerator
} from '../../utils/tools';
import { getFirstProductCategory, sortItemsPositionForShop } from '../../utils/product';
import defaultImg from '../../assets/pictures/no_image.jpeg';
import store from '../../utils/store';
import {
  ERROR_UPDATE_PRODUCT,
  ERROR_WRONG_INFORMATIONS,
  ERROR_DUPLICATION,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_COLLECT,
  ORDER_TYPE_SEAT,
  SUITABLE_ORDER_TYPES,
  ERROR_SYNCHRONIZATION_WITH_SHOP
} from '../../constants';
import { getShopsToSynchronise } from '../../utils/shopUtils';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';
import apiService from '@dishopsaas/dishop-backend-api-service'
const closeDeleteModal = component => {
  const { showModal } = component.props;
  component.setState({ synchronize: false, isSuppression: false, selectedShops: {} });
  showModal(false);
};
export const handleRemoveProduct = (product, component) => {
  const { showModal, shopId, shops, nbShops } = component.props;
  const { name, key } = product;
  const nbShopsToSync = _.size(getShopsToSynchronise())
  const modalData = {
    color: 'danger',
    title: `Êtes-vous sûr(e) de vouloir supprimer le produit ${name.toLowerCase()} ?`,
    showCancelBtn: true,
    textCheckbox: nbShops > 1 && nbShopsToSync > 1 && 'Supprimer ce produit sur un ou plusieurs magasins',
    onChangeCheckbox: synchronize => {
      component.setState({ synchronize: !synchronize });
    },
    handleClose: () => {
      closeDeleteModal(component);
    },
    btnColor: 'danger',
    onClick: () => {
      component.state.synchronize && nbShops > 1 && nbShopsToSync > 1 ?
        component.setState({
          selectedShops: { [shopId]: shops[shopId] },
          showModal: true,
          productKey: key
        }) :
        handleRemoveProductSubmit(key, component);
      if (!component.state.synchronize) {
        component.setState({ showModal: false });
        closeDeleteModal(component);
      }

    },
    btnTxt: 'Supprimer'
  };
  showModal(modalData);
};

export const handleRemoveProductSubmit = async (productKey, component) => {
  const { openErrorModal, sections = {}, sectionKey } = component.props;
  const { synchronize = false, selectedShops } = component.state;
  const { key = '' } = sections[sectionKey];
  try {
    component.setState({ removeProductModal: false });
    if (!synchronize || (synchronize && _.size(selectedShops) > 1)) {
      component.setState({ isLoadingProduct: true })
      await deleteProduct(productKey, key, synchronize, selectedShops);
      await component.setState({ isSuppression: false, showModal: false, isLoadingProduct: false });
      await closeDeleteModal(component)
    }

    else { openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP); component.setState({ isLoadingProduct: false }) };


  } catch (error) {
    await component.setState({ isSuppression: false, showModal: false, isLoadingProduct: false });
    await closeDeleteModal(component)
    openErrorModal(ERROR_UPDATE_PRODUCT);

  }
};

export const returnImage = image => {
  return image || defaultImg;
};

export const handleDragProduct = async (event, products, component) => {
  const { shopId } = store.getState().user;
  const { openErrorModal, sectionKey, handleStateChange, sections } = component.props;
  const { currentSectionKey } = component.state;
  const { active, over } = event;
  component.setState({ isDragging: false });
  if (active && over) {
    handleStateChange({ currentSectionKey: null, highlightSection: {} });
    if (currentSectionKey && currentSectionKey !== sectionKey) {
      try {
        handleStateChange({ expanded: currentSectionKey });
        delete sections[sectionKey].products[active.id];
        sections[currentSectionKey].products = { ...sections[currentSectionKey].products, [active.id]: products[active.id] };
        await apiService.menusUpsert([shopId, 'sections'], sections, { updateMode: 'replace' })
      }
      catch (error) {
        openErrorModal(ERROR_UPDATE_PRODUCT);
      }

    }
    if (active.id !== over.id) {
      try {
        component.setState({
          activeId: null,
          isSorting: true
        });
        await sortItemsPositionForShop(event, products, [shopId, 'sections', sectionKey, 'products']);
        component.setState({
          isSorting: false
        });
      } catch (error) {
        openErrorModal(ERROR_UPDATE_PRODUCT);
      }
    } else {
      component.setState({
        isSorting: false
      });
    }
  }

};

export const updateAvailableProduct = async (productKey, product, component) => {
  const { sections, sectionKey, openErrorModal } = component.props;
  try {
    product.disabled = !product.disabled;
    await updateProduct(product, sections[sectionKey], false);
  } catch (err) {
    openErrorModal(ERROR_UPDATE_PRODUCT);
    sendCloudWatchAlert(`Could not enable/disable product ${err}`);
  }
};

export const getMinimumPriceFreeProduct = product => {
  let minPrice = null;
  const firstShopCategory = getFirstProductCategory(product);
  if (firstShopCategory) {
    _.map(firstShopCategory.items, item => {
      if (item) {
        const { price } = item;
        if (!minPrice || price < minPrice) {
          minPrice = price;
        }
      }
    });
  }
  return displayPriceFormat(minPrice);
};

export const handleNewProduct = (e, sectionKey, component) => {
  e.stopPropagation();
  component.setState({
    productModalOpen: true,
    sectionKey,
    croppedImage: {},
    product: {},
    categoriesArray: []
  });
};

export const handleSubmitProduct = async (component, shopsMenu, selectedCategories) => {
  const {
    product,
    categoriesArray = [],
    productModalOpen,
    synchronize = false,
    disabledOrderTypes
  } = component.state;
  const { openErrorModal, sectionKey, sections } = component.props;
  const {
    name,
    description,
    stock = null,
    ref = '',
    key = keyGenerator('PRODUCT'),
    price,
    preparationTime = null,
    unit = null,
    disabled = false
  } = product;
  let { position } = product;
  let categories = '';
  categoriesArray.forEach(category => {
    const { key } = category;
    categories += `${categories === '' ? '' : ','}${key.includes(',') ? key.split(',')[0] : key}`;
  });
  position = productModalOpen
    ? parseInt(sections[sectionKey].products ? _.size(sections[sectionKey].products) : 0, 10)
    : parseInt(position, 10);
  const nameToCkeck = name ? name.replace(/\s+/g, '') : '';
  if (_.size(categoriesArray) < _.size(selectedCategories) && checkIntegrationAccess('products', 'disableOptionList')) {
    openErrorModal(ERROR_WRONG_INFORMATIONS);
    return
  }
  if (
    nameToCkeck &&
    nameToCkeck.length > 0 &&
    parseFloat(price) >= 0 &&
    position >= 0 &&
    (ref !== '' || !hasExternalIntegration())
  ) {
    try {
      component.setState({
        isLoadingProduct: true
      });
      const renderProduct = {
        ...product,
        name,
        price: String(price),
        stock,
        position,
        categories,
        key,
        description,
        disabled,
        preparationTime: isIntegerNotNull(preparationTime) ? parseInt(preparationTime, 10) : '',
        unit: unit === 'unit' ? 0 : unit,
        disabledDelivery: disabledOrderTypes.includes(SUITABLE_ORDER_TYPES[ORDER_TYPE_DELIVERY]),
        disabledCS: disabledOrderTypes.includes(SUITABLE_ORDER_TYPES[ORDER_TYPE_SEAT]),
        disabledCC: disabledOrderTypes.includes(SUITABLE_ORDER_TYPES[ORDER_TYPE_COLLECT])
      };
      for (const i in renderProduct) {
        if (renderProduct[i] === null) {
          delete renderProduct[i];
        }
      }

      if (!synchronize || (synchronize && _.size(shopsMenu) > 1)) {
        await updateProduct(renderProduct, sections[sectionKey], synchronize, shopsMenu);
        component.setState({
          updateProductModalOpen: false,
          productModalOpen: false,
          isLoadingProduct: false,
          synchronize: false,
          showModal: false
        });
      }

      else { openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP); component.setState({ isLoadingProduct: false }) };

    } catch (err) {

      openErrorModal(ERROR_UPDATE_PRODUCT);
    }
  } else {
    openErrorModal(ERROR_WRONG_INFORMATIONS);
  }
  component.setState({
    isLoadingProduct: false, selectedShops: {}
  });
}



export const handleDuplicateProduct = async (product, component) => {
  const { openErrorModal, sectionKey, sections } = component.props;
  const newProduct = { ...product, key: keyGenerator('PRODUCT') };
  try {
    await updateProduct(newProduct, sections[sectionKey], false);
  } catch (err) {
    openErrorModal(ERROR_DUPLICATION);
  }
}

export const addOption = (name, key, itemIndex, component) => {
  component.setState(prevState => {
    const { categoriesArray } = prevState;
    if (itemIndex > -1) categoriesArray.splice(itemIndex, 1);
    else
      categoriesArray.push({
        name,
        key
      });
    return { categoriesArray };
  });
}

export const handleChangeOrderTypes = ({ target }, component) => {
  const { value } = target;
  component.setState({
    disabledOrderTypes: value
  });
}

export const getDisabledOrderTypes = product => {
  const { disabledDelivery = false, disabledCC = false, disabledCS = false } = product;
  const disabledOrderTypes = [];
  if (disabledDelivery) disabledOrderTypes.push(SUITABLE_ORDER_TYPES[ORDER_TYPE_DELIVERY]);
  if (disabledCS) disabledOrderTypes.push(SUITABLE_ORDER_TYPES[ORDER_TYPE_SEAT]);
  if (disabledCC) disabledOrderTypes.push(SUITABLE_ORDER_TYPES[ORDER_TYPE_COLLECT]);
  return disabledOrderTypes;
};
export const handleProduct = (categoriesArray, product, component) => {
  const { name = '' } = product;
  component.setState({
    updateProductModalOpen: true,
    categoriesArray,
    product,
    productName: name,
    disabledOrderTypes: getDisabledOrderTypes(product)
  });
}

export const handleChange = ({ target }, component) => {
  component.setState(prevState => ({
    product: { ...prevState.product, [target.id]: target.value }
  }));
}

export const handleChangeNumber = ({ target }, component) => {
  const { value, id } = target;
  component.setState(prevState => ({
    product: { ...prevState.product, [id]: value >= 0 ? value : 0 }
  }));
}

export const handleRemoveImage = component => {
  component.setState(prevState => ({
    product: { ...prevState.product, image: '', image64: '' }
  }));
}

export const setCroppedImage = async (croppedImage, component) => {
  component.setState(prevState => ({
    product: { ...prevState.product, image64: croppedImage.split(',')[1] }
  }));
}

export const handleStartDrag = (event, component) => {
  component.setState({ activeId: event.active.id, isDragging: true });
}

export const handleDragMove = (event, component) => {
  const { sections, handleStateChange, sectionKey } = component.props;
  const { currentSectionKey } = component.state;
  if (component.state.isDragging) {
    document.addEventListener('mousemove', (event) => handleMouseMove(event, component));
    document.addEventListener('touchmove', (event) => handleMouseMove(event, component));
    if (currentSectionKey) {
      handleStateChange({ highlightSection: currentSectionKey !== sectionKey ? sections[currentSectionKey] : {} });
    }
  }
};

export const handleMouseMove = (event, component) => {
  if (!component.isProcessingMouseMove && component.state.isDragging) {
    component.isProcessingMouseMove = true;
    requestAnimationFrame(() => {
      const mouseX = event.clientX || (event.touches && event.touches[0].clientX);
      const mouseY = event.clientY || (event.touches && event.touches[0].clientY);
      const sections = document.querySelectorAll('.section');
      sections.forEach(section => {
        const sectionRect = section.getBoundingClientRect();
        const sectionKey = section.getAttribute('data-section-key');
        if (
          mouseX >= sectionRect.left &&
          mouseX <= sectionRect.right &&
          mouseY >= sectionRect.top &&
          mouseY <= sectionRect.bottom
        ) {
          if (component.state.mounted) {
            component.setState({ currentSectionKey: sectionKey })
          }
        }
      });
      component.isProcessingMouseMove = false;
    });
  }
};








